import LaborInformationBox from '@web/labor/LaborInformationBox/LaborInformationBox';

export default {
  ReactComponent: LaborInformationBox,
  bindings: {
    sectionValue: '<',
    sectionPropertyName: '<',
    navigateTo: '&',
    openAddShiftModal: '&',
    hasVisitiedLaborCostSettingsTab: '<',
    employees: '<',
    positions: '<',
  },
};
